export default __webpack_public_path__ + "static/media/404 error.a5649c58.svg";